import { useState } from 'react';
import { X, Phone, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export function PromoWidget() {
  const [isOpen, setIsOpen] = useState(true);

  if (!isOpen) return null;

  return (
    <div className="fixed left-0 top-1/2 -translate-y-1/2 z-40">
      <div className="relative">
        {/* Main Widget Card */}
        <div className="bg-gradient-to-br from-blue-600 to-blue-700 text-white shadow-2xl rounded-r-lg overflow-hidden w-80 mx-0">
          {/* Close Button */}
          <button
            onClick={() => setIsOpen(false)}
            className="absolute top-2 right-2 p-1 hover:bg-white/20 rounded transition-colors z-10"
            aria-label="Close promotion"
          >
            <X size={20} />
          </button>

          {/* Content */}
          <div className="p-6 pt-8">
            {/* Promo Badge */}
            <div className="inline-block bg-yellow-400 text-blue-900 px-3 py-1 rounded-full text-sm font-bold mb-3">
              LIMITED OFFER
            </div>

            {/* Heading */}
            <h3 className="text-lg font-bold mb-2">
              Save 5% on Home Moves
            </h3>

            {/* Description */}
            <p className="text-sm text-blue-100 mb-4">
              Call us today or get a free quote. Enter code at checkout.
            </p>

            {/* Promo Code Box */}
            <div className="bg-white/15 border-2 border-yellow-400 rounded-lg p-3 mb-4 text-center">
              <p className="text-xs text-blue-100 mb-1">Use Code:</p>
              <p className="text-xl font-bold font-mono tracking-wider">
                removals123
              </p>
            </div>

            {/* Call to Action Buttons */}
            <div className="space-y-3">
              {/* Call Button */}
              <a
                href="tel:01217527107"
                className="flex items-center justify-center gap-2 w-full bg-yellow-400 hover:bg-yellow-500 text-blue-900 font-bold py-3 rounded-lg transition-colors"
              >
                <Phone size={18} />
                Call: 0121 752 7107
              </a>

              {/* Quote Button */}
              <Link
                to="/quote"
                onClick={() => setIsOpen(false)}
                className="flex items-center justify-center gap-2 w-full bg-white hover:bg-blue-50 text-blue-700 font-bold py-3 rounded-lg transition-colors"
              >
                Get Free Quote
                <ArrowRight size={18} />
              </Link>
            </div>

            {/* Footer Text */}
            <p className="text-xs text-blue-100 text-center mt-4">
              🚚 Fast • Professional • Insured
            </p>
          </div>
        </div>

        {/* Tab on Edge (for when closed) */}
        {!isOpen && (
          <button
            onClick={() => setIsOpen(true)}
            className="absolute left-0 top-1/2 -translate-y-1/2 bg-gradient-to-r from-blue-600 to-blue-700 text-white px-2 py-4 rounded-r-lg hover:from-blue-700 hover:to-blue-800 transition-colors shadow-lg font-bold text-xs writing-vertical-rl"
            title="Open offer"
          >
            5% OFF
          </button>
        )}
      </div>
    </div>
  );
}
